module.exports = __webpack_public_path__ + "static/passport_red-6ccab806138c8bae973636ea2501b76f.png";